define('views/modals/claim/doc-collection',[
    'jquery',
    'underscore',
    'mediator',

    'views/base/view',
    'views/base/collection',
    'lib/utils',

    'text!templates/modals/claim/doc-collection-item.ejs'
], function(
    $, _, mediator,
    View, CollectionView, utils,

    templateItem
) {
    'use strict';

    var ClaimDocItem = View.extend({
        template: templateItem,
        tagName: 'tr'
    });

    var ClaimDocCollectionView = CollectionView.extend({
        autoRender: true,
        tagName: 'tbody',
        region: 'claim-docs',
        itemView: ClaimDocItem
    });

    return ClaimDocCollectionView;
});

